import { CoreMenu } from '@core/types'
import adminMenu from '../../assets/menus/admin_menu.json';
import finalMenu from '../../assets/menus/final_user.json';
import superMenu from '../../assets/menus/super_user.json';

let mainMenu = []

if (localStorage.getItem('user_type') === 'super') {
  mainMenu = superMenu;
} else if (localStorage.getItem('user_type') === 'admin') {
  if (localStorage.getItem('profile') != 'designer') {
    mainMenu = adminMenu;
  } else {
    mainMenu = finalMenu;
  }
} else if (localStorage.getItem('user_type') === 'final') {
  mainMenu = finalMenu;
}

export const menu: any[] = mainMenu